import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sp-disclaimer-popup',
  templateUrl: './disclaimer-popup.component.html',
  styleUrls: ['./disclaimer-popup.component.scss'],
})
export class DisclaimerPopupComponent {
  constructor(public dialogRef: MatDialogRef<DisclaimerPopupComponent>) {}

  public clickAccept(): void {
    this.dialogRef.close(true);
  }
}
